module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUCAIAAACMMcMmAAAAO0lEQVRIx2Nk0K5noDFgHC52rNh+meZ2/P//f1jY8W7tFprbcU5QbdSOUTuGZNodLvmcHmXiaB1FNAAAi90fJbdXtPoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cr.png
// module id = 803
// module chunks = 0